<template>
    <button
        :class="newClass"
        :style="{ width, height, backgroundColor, color: textColor }"
        :disabled="disabled"
        @click="e => !disabled && $emit('click', e)"
    >
        <slot />
    </button>
</template>
<script>
export default {
    props: {
        backgroundColor: {
            type: String,
            required: false,
            default: "#000"
        },
        textColor: {
            type: String,
            required: false,
            default: "#FFF"
        },
        width: {
            type: String,
            required: false
        },
        height: {
            type: String,
            required: false
        },
        size: {
            type: String,
            default: "m"
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        newClass() {
            const { inactiveColor, className, size } = this;
            return [className, inactiveColor && "inactiveColor", size];
        }
    }
};
</script>
<style scoped lang="scss">
button {
    border: none;
    border-radius: 30px;
    text-transform: uppercase;
    transition: opacity 0.3s ease;
    // m, s, and l define the differents sizes for this button.
    // It works with props. default is m.
    &.m {
        padding: 10px 15px;
    }
    &.xl {
        padding: 20px 25px;
    }
    &.l {
        padding: 15px 25px;
        @media (max-width: 1440px) {
            font-size: 14px;
            padding: 10px 20px;
        }
    }
    &.xs {
        font-size: 0.8em;
        padding: 2px 10px 2px 10px;
    }
    &.inactiveColor {
        background-color: grey;
    }
    &:disabled {
        background-color: grey;
        cursor: no-drop;
    }
    &:hover {
        opacity: 0.8;
    }
}
</style>



// WEBPACK FOOTER //
// DefaultButton.vue?f6a2b5e4